var owlCarousel = $('.owl-carousel');

owlCarousel.mouseover(function(){
  owlCarousel.trigger('stop.owl.autoplay');
});

owlCarousel.mouseleave(function(){
  owlCarousel.trigger('play.owl.autoplay',[5000]);
});
